import { Adapter as t } from "../../../adapter.js";
import { TicketTaxModel as r } from "./ticketTax.model.js";
class n extends t {
  adapt(e) {
    return new r({
      amount: e.amount,
      name: e.name,
      rate: e.rate,
      taxId: e.tax_id
    });
  }
  serialize(e) {
    throw new Error("Method not implemented.");
  }
}
export {
  n as TicketTaxAdapter
};
//# sourceMappingURL=ticketTax.adapter.js.map
